(() => {
  var __defProp = Object.defineProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

  // scripts/settings/responsive.ts
  var RESPONSIVE_SIZES = {
    xxsmall: 375,
    xsmall: 480,
    small: 750,
    medium: 1100,
    large: 1350,
    xlarge: 1650,
    xxlarge: 2e3
  };
  var RESPONSIVE_DEFINITIONS = Object.fromEntries(
    Object.entries(RESPONSIVE_SIZES).map(([k, v]) => [k, `${v}px`])
  );
  var responsiveMediaAbove = (definition) => {
    if (typeof window === "undefined") return false;
    return window.innerWidth >= RESPONSIVE_SIZES[definition];
  };

  // scripts/tools/section.ts
  var ATTR_SECTION_INITIALIZED = "data-section-initialized";
  var _Section = class _Section {
    constructor(element, selector) {
      // Class itself.
      __publicField(this, "selector");
      __publicField(this, "container");
      __publicField(this, "shopifyContainer");
      __publicField(this, "id");
      __publicField(this, "innerHtmlObserver");
      __publicField(this, "onInnerHtmlMutationObserved", (mutations, observer) => {
        if (!mutations.length) return;
        if (!this.shopifyContainer) return;
        const [mutation] = mutations;
        const removedNodes = [];
        mutation.removedNodes.forEach((n) => removedNodes.push(n));
        const index = removedNodes.findIndex((rn) => rn === this.shopifyContainer);
        if (index === -1) return;
        console.log("Section", this.id, "reloaded.");
        this.dispose();
        _Section.recheck(this.selector);
      });
      this.container = element;
      this.selector = selector;
      this.container.setAttribute(ATTR_SECTION_INITIALIZED, "true");
      this.shopifyContainer = this.container.parentElement;
      if (this.shopifyContainer && this.shopifyContainer.id) {
        try {
          this.id = this.shopifyContainer.id.replace(/shopify-section-/, "");
        } catch (e) {
          console.warn(e);
        }
      }
    }
    /**
     * Register a given section handler for a section selector.
     * 
     * @param selector Selector used to query on the section(s).
     * @param t The handling class for that section.
     * @returns The list of currently registered sections.
     */
    static register(selector, t) {
      const sections = [];
      document.querySelectorAll(selector).forEach((element) => {
        if (_Section.isRegistered(element)) return;
        const sect = new t(element, selector);
        sections.push(sect);
        sect.queryChildren(element);
        sect.init();
        sect.attachEvents(element);
      });
      this.registrations[selector] = t;
      return sections;
    }
    static recheck(selector) {
      const t = this.registrations[selector];
      if (!t) return [];
      return _Section.register(selector, t);
    }
    /**
     * Checks if the given section has been registered or not.
     * 
     * @param element Element to check if has been registered.
     * @returns True if registered, otherwise false.
     */
    static isRegistered(element) {
      return element.hasAttribute(ATTR_SECTION_INITIALIZED);
    }
    replaceContainer(newContainer) {
      this.container.removeAttribute(ATTR_SECTION_INITIALIZED);
      this.detatchEvents(this.container);
      this.container.innerHTML = newContainer.innerHTML;
      this.container.setAttribute(ATTR_SECTION_INITIALIZED, "true");
      this.queryChildren(this.container);
      this.init();
      this.attachEvents(this.container);
    }
    init() {
    }
    dispose() {
      this.container.removeAttribute(ATTR_SECTION_INITIALIZED);
      this.detatchEvents(this.container);
      if (this.innerHtmlObserver) this.innerHtmlObserver.disconnect();
    }
  };
  __publicField(_Section, "registrations", {});
  var Section = _Section;

  // scripts/tools/constants/classes.ts
  var CLASS_OPEN = "is-open";

  // scripts/sections/footer.ts
  var SEL_LINKS = "[data-footer-link]";
  var SEL_SUBLINKS = "[data-footer-sublinks]";
  var Footer = class extends Section {
    constructor() {
      super(...arguments);
      __publicField(this, "onLinkClick", (e) => {
        var _a;
        if (responsiveMediaAbove("medium")) return;
        e.preventDefault();
        const self = e.target;
        const sublink = (_a = self.parentElement) == null ? void 0 : _a.querySelector(SEL_SUBLINKS);
        const isOpen = sublink && sublink.classList.contains(CLASS_OPEN);
        this.container.querySelectorAll(SEL_LINKS).forEach((l) => {
          l.classList.remove(CLASS_OPEN);
        });
        this.container.querySelectorAll(SEL_SUBLINKS).forEach((sl) => {
          sl.classList.remove(CLASS_OPEN);
        });
        if (!isOpen) {
          self.classList.add(CLASS_OPEN);
          sublink == null ? void 0 : sublink.classList.add(CLASS_OPEN);
        }
      });
    }
    queryChildren(container) {
    }
    attachEvents(container) {
      container.querySelectorAll(SEL_LINKS).forEach((e) => {
        e.addEventListener("click", this.onLinkClick);
      });
    }
    detatchEvents(container) {
      container.querySelectorAll(SEL_LINKS).forEach((e) => {
        e.removeEventListener("click", this.onLinkClick);
      });
    }
  };
  Section.register("[data-footer]", Footer);
})();
